var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radial-bar" }, [
    _c(
      "svg",
      {
        staticClass: "radial-bar__inner",
        attrs: {
          height: "48",
          width: "48",
          viewBox: "0 0 48 48",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("circle", {
          staticClass: "radial-bar__bar",
          attrs: {
            cx: "24",
            cy: "24",
            r: "22",
            fill: "transparent",
            stroke: "#edf4fa",
            "stroke-width": "3"
          }
        }),
        _c("circle", {
          staticClass: "radial-bar__bar",
          attrs: {
            cx: "24",
            cy: "24",
            r: "22",
            fill: "transparent",
            stroke: "#1A82CB",
            "stroke-width": "3",
            "stroke-dasharray": _vm.val
          }
        }),
        _c(
          "text",
          {
            staticClass: "radial-bar__value",
            attrs: {
              x: "50%",
              y: "53%",
              "dominant-baseline": "middle",
              "text-anchor": "middle"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.value) + "%\n    ")]
        )
      ]
    ),
    _c("div", { staticClass: "radial-bar__title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }